import { Chip } from '@mui/material';
import type { BookingStatus } from '../../lib/facilities-api';
import { useT } from '../../i18n';

const COLORS: Record<BookingStatus, 'default' | 'info' | 'success' | 'warning' | 'error'> = {
  PENDING_APPROVAL: 'warning',
  CONFIRMED: 'success',
  CANCELLED: 'default',
  REJECTED: 'error',
  COMPLETED: 'info',
};

// status -> i18n key (shared by the bookings pages).
export const BOOKING_STATUS_KEY: Record<BookingStatus, string> = {
  PENDING_APPROVAL: 'book.statusPending',
  CONFIRMED: 'book.statusConfirmed',
  CANCELLED: 'book.statusCancelled',
  REJECTED: 'book.statusRejected',
  COMPLETED: 'book.statusCompleted',
};

export function BookingStatusChip({ status }: { status: BookingStatus }) {
  const t = useT();
  return (
    <Chip
      label={t(BOOKING_STATUS_KEY[status] ?? status)}
      color={COLORS[status] ?? 'default'}
      size="small"
    />
  );
}
